__turbopack_context__.v({
  "addressSection": "hero-desktop-module-scss-module__xUyGkW__addressSection",
  "container": "hero-desktop-module-scss-module__xUyGkW__container",
  "content": "hero-desktop-module-scss-module__xUyGkW__content",
  "gallery": "hero-desktop-module-scss-module__xUyGkW__gallery",
  "mlsSection": "hero-desktop-module-scss-module__xUyGkW__mlsSection",
  "priceGroup": "hero-desktop-module-scss-module__xUyGkW__priceGroup",
  "priceRow": "hero-desktop-module-scss-module__xUyGkW__priceRow",
});
